<template>
  <div class="video-edit">
    <p class="title">音频集详情</p>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      size="small"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item label="名称：" required>
            <el-input v-model="ruleForm.audioSetName" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="描述：" required>
            <el-input
              :rows="3"
              type="textarea"
              v-model="ruleForm.audioSetDesc"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="音频分类：" prop="categoryName" required>
            <el-input
              v-model="ruleForm.categoryName"
              placeholder="请输入"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="配图：" required>
            <av-preview
              :src="ruleForm.coverUrl"
              type="image"
              :deleteable="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="音频列表：">
            <Table :data="ruleForm.audioInfoList" row-key="uuid" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0" class="center">
        <back-button :pathOptions="pathOptions" :floatLeft="false" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Table from "./table.js";
import AvPreview from "@/components/av-preview/index";
import { getAudiosetInfo } from "@/api/audioSet";
import BackButton from "@/components/backButton/index.vue";

export default {
  components: { Table, AvPreview, BackButton },
  data() {
    return {
      pathOptions: {
        path: "/audioSet",
      },
      value: [],
      filterMethod(query, item) {
        return item.videoName.indexOf(query) > -1;
      },
      ruleForm: {
        audioSetName: "",
        audioSetDesc: "",
        categoryName: "",
        coverUrl: "",
      },
      data: [],
      props: {
        key: "uuid",
        label: "videoName",
      },
      diaVisible: false,
      showError: false,
      editFlag: false,
      edituuid: "",
      selVideo: [],
      showCover: false, //控制封面overlay
      showViewer: false, //控制图片预览
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    },
  },
  created() {
    if (this.$route.query.id) {
      this.editFlag = true;
      getAudiosetInfo({ uuid: this.$route.query.id }).then((res) => {
        if (!res || res.code != 0) return;
        this.ruleForm = res.data;
        this.edituuid = res.data.uuid;
        this.selVideo = [];
      });
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.video-edit {
  $textColor: #51627d;
  $textSize: 14px;
  @mixin text {
    color: $textColor;
    font-size: $textSize;
  }
  .form {
    padding: 10px 34px;
  }
  .title {
    color: #343c4a;
    font-size: 16px;
    margin: 0;
    padding: 14px 0 10px 34px;
    border-bottom: 1px solid #edf1f8;
  }
  /deep/ .el-form-item__label {
    @include text;
  }
  /deep/ .el-radio__label {
    @include text;
    font-weight: normal;
  }
  /deep/ .is-checked .el-radio__label {
    color: #3a85ff;
  }
  /deep/ .scale .el-input {
    width: 50%;
    @include text;
  }
  .form-select {
    width: 100%;
    &.has-btn {
      width: calc(100% - 120px);
    }
  }
  .button-dept {
    margin-left: 10px;
    width: 100px;
  }
  #video-output {
    position: relative;
    #video {
      object-fit: cover;
      width: 360px;
      height: 180px;
      cursor: default;
    }
    .cover-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 30%;
      background-color: rgba(1, 1, 1, 0.5);
      z-index: 199;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      color: #ffffff;
      cursor: default;
      .delete {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color: #f7f9fc;
    width: 104px;
    height: 104px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 84px;
    height: 84px;
    line-height: 84px;
    text-align: center;
  }
  .avatar {
    width: 104px;
    height: 104px;
    display: block;
  }
  .upload-text {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    color: $textColor;
    font-size: 13px;
  }
  .center {
    margin-top: 20px !important;
    text-align: center;
  }
}
</style>
